import React, { FC } from 'react';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import eventTypes from '../../../../enums/Event.enums';
import { iconSize } from '../../../../constants/icon.constants';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';
import Icon from '../../../@shared/icon';
import { TNavigationBoxMobileProps } from '../types/navigationBar.types';
import useGetBuildAndPriceLink from '../../../../hooks/useGetBuildAndPriceLink';
import DictionaryTerm from '../../../@shared/dictionaryTerm';

const NavigationBoxMobile: FC<TNavigationBoxMobileProps> = (props) => {
  const {
    title,
    sticky,
    button1,
    clickPageNavEvent,
    handleClick,
    dropdownIsOpen,
    handleCloseDropdown,
    dropDownSeriesData,
    formTitleUrl,
    contextItemUrl,
    isUnderSuperSerie,
    enableBuildPriceCTA,
  } = props;
  const icon = dropdownIsOpen ? 'arrow-chevron-up' : 'arrow-chevron-down';
  const buildAndPriceUrl = useGetBuildAndPriceLink('series');
  const hasButtons = (button1?.label && button1?.url) || (enableBuildPriceCTA && buildAndPriceUrl);
  const hasDropDownSeriesData = dropDownSeriesData && dropDownSeriesData?.length > 1;

  return (
    <div
      className={`navigation-bar-mobile-bottom ${sticky ? 'sticky-element--hide' : ''} ${
        dropdownIsOpen ? 'navigation-bar-mobile-bottom--dropdown-open' : ''
      }`}
    >
      <span className="navigation-bar-mobile-bottom__dropdown">
        <p className="navigation-bar-mobile-bottom__dropdown-data">{title}</p>
        {hasDropDownSeriesData && (
          <Icon
            iconName={icon}
            color="primary"
            extraClassName="navigation-bar-mobile-bottom__dropdown-icon"
            size={iconSize.mbl}
            onClick={handleClick}
          />
        )}
      </span>
      {hasButtons && (
        <div className={'navigation-bar-mobile-bottom__button-container'}>
          {enableBuildPriceCTA && buildAndPriceUrl && 
            <RoutableNotEditableLink
            href={appendRootToInternalLink(buildAndPriceUrl)}
            className="navigation-bar-mobile-bottom__button"
            onClick={() => clickPageNavEvent(eventTypes.ctaEvent, button1?.label)}
          >
            <DictionaryTerm keyword={'cnhi-build-price'} />
          </RoutableNotEditableLink>
          }
          {button1?.label && button1?.url && <RoutableNotEditableLink
            href={appendRootToInternalLink(button1?.url)}
            className="navigation-bar-mobile-bottom__button"
            onClick={() => clickPageNavEvent(eventTypes.ctaEvent, button1?.label)}
          >
            {button1?.label}
          </RoutableNotEditableLink>}
        </div>
      )}
      {dropdownIsOpen && (
        <ul className="navigation-bar-mobile-bottom__dropdown-list">
          <Icon
            iconName="action-close"
            extraClassName="navigation-bar-mobile-bottom__dropdown-close"
            size={iconSize.md}
            onClick={handleCloseDropdown}
          />
          {dropDownSeriesData?.map((dropDownData, index) => {
            const redirectUrl = formTitleUrl(contextItemUrl, dropDownData?.titleUrl, !!isUnderSuperSerie);
            return dropDownData.title !== null && dropDownData.title !== '' ? (
              <li className="navigation-bar-mobile-bottom__dropdown-list-item" key={index} onClick={handleCloseDropdown}>
                <RoutableNotEditableLink
                  href={redirectUrl}
                  onClick={() => clickPageNavEvent(eventTypes.navEvent, dropDownData?.title, index + 1)}
                >
                  {dropDownData.title}
                </RoutableNotEditableLink>
              </li>
            ) : null;
          })}
        </ul>
      )}
    </div>
  );
};

export default NavigationBoxMobile;
